module.exports = __webpack_public_path__ + "img/logo_pos_indonesia1.13fe1090.png";